import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "vertical"]

  toggle(event) {
    const index = event.params.index
    const content = this.contentTargets[index]
    const vertical = this.verticalTargets[index]

    if (!content) return

    const isHidden = content.classList.contains("hidden")

    // Close all panels first
    this.contentTargets.forEach((el, i) => {
      el.classList.add("hidden")
      if (this.verticalTargets[i]) {
        this.verticalTargets[i].style.opacity = "1"
      }
    })

    // Toggle the clicked panel
    if (isHidden) {
      content.classList.remove("hidden")
      if (vertical) {
        vertical.style.opacity = "0"
      }
    }
  }
}
